(() => {
  const init = () => {
    const header = document.querySelector('[data-al-header]');
    if (!header || header.classList.contains('is-ready')) return;
    const nav = header.querySelector('#al-main-nav');
    const toggle = header.querySelector('.al-menu-toggle');
    const disclosures = [...header.querySelectorAll('.al-nav-disclosure')];
    const desktop = window.matchMedia('(min-width:1024px)');
    const close = () => {
      disclosures.forEach(item => { item.open = false; });
      header.classList.remove('is-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
    };
    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-menu-open');
      toggle.setAttribute('aria-expanded', String(open));
      if (!open) disclosures.forEach(item => { item.open = false; });
    });
    disclosures.forEach(item => {
      item.querySelector('summary').addEventListener('click', () => {
        if (!item.open) disclosures.forEach(other => { if (other !== item) other.open = false; });
      });
    });
    document.addEventListener('click', event => { if (!header.contains(event.target)) close(); });
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const opened = disclosures.find(item => item.open && item.contains(document.activeElement));
      if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
      else { close(); if (!desktop.matches) toggle.focus(); }
    });
    nav.addEventListener('focusout', event => {
      if (desktop.matches && event.relatedTarget && !nav.contains(event.relatedTarget)) disclosures.forEach(item => { item.open = false; });
    });
    let threshold = header.offsetTop + header.offsetHeight - header.querySelector('.al-nav-bar').offsetHeight;
    let frame = 0;
    const updateSticky = () => {
      frame = 0;
      header.classList.toggle('is-sticky', desktop.matches && window.scrollY > threshold);
    };
    window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(updateSticky); }, {passive:true});
    window.addEventListener('resize', () => {
      header.classList.remove('is-sticky');
      threshold = header.offsetTop + header.offsetHeight - header.querySelector('.al-nav-bar').offsetHeight;
      updateSticky();
    }, {passive:true});
    desktop.addEventListener('change', close);
    header.classList.add('is-ready');
    updateSticky();
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
